export const FCI_APIS = {
  LACARDIO: {
    PATIENT_CREATION: (document_type: string, document_number: string) =>
      `/api/lacardio/patient-creation/${document_type}/${document_number}/`,
    PATIENT: (document_type: string, document_number: string) =>
      `/api/lacardio/patient/${document_type}/${document_number}/`,
    SPECIALIST: '/api/lacardio/specialist/',
    PACKETS: '/api/lacardio/patient/packets',
    GROUPS: '/api/lacardio/patient/groups/',
    RESULTS_LOGIN: '/api/lacardio/patient/login/',
    LOGIN: '/api/lacardio/admin/patient/login/'
  }
} as const;
